import React from 'react'
import { useDispatch } from 'react-redux'

import { ReactComponent as ConfirmVersionUpdateIcon } from '../../assets/icons/yellow-exclamation.svg'

import styles from './VNConfirmVersionUpdateButton.module.scss'
import { setShouldShowUpdateModal } from '../ActionCreators'

const VNConfirmVersionUpdateButton = () => {
  const dispatch = useDispatch()

  // For now, always disable the update button.
  const updateAvailable = false // useSelector(getUpdateAvailable)
  const triggerUpdate = () => {
    dispatch(setShouldShowUpdateModal(true))
  }

  return (
    <>
      {updateAvailable && (
        <div className={styles.versionUpdateIcon}>
          <ConfirmVersionUpdateIcon onClick={triggerUpdate} />
        </div>
      )}
    </>
  )
}

export default VNConfirmVersionUpdateButton
